import { render } from "./ModalButton.vue?vue&type=template&id=2e515d62"
import script from "./ModalButton.vue?vue&type=script&lang=ts"
export * from "./ModalButton.vue?vue&type=script&lang=ts"

import "./ModalButton.vue?vue&type=style&index=0&id=2e515d62&lang=scss"
script.render = render

export default script